export const labels = {
	remove: {
		label: "Label.MobileCreator.SpreadOverview.Spread.Remove",
		default: "Remove",
	},

	spreadOverviewTitle: {
		label: "Label.MobileCreator.SpreadOverview.Title",
		default: "Spread overview",
	},
};
